angular.module('impactx.selectionDialog').controller('SelectionDialogCtrl', ['$scope', '$mdDialog', 'ToastService', 'TranslationService', function($scope, $mdDialog, ToastService, TranslationService) {
    $scope.showDialog = false;
    $scope.getDeleteLabel = function() {
        return $scope.trns.authdeletedtoast.replace("^0", $scope.sets.authorizationPopup.entries.filter(function(el) {
            return el.id === $scope.lastDeleted.authSetId
        })[0].value);
    };
    $scope.showDeletionToast = function() {
        ToastService.openActionToast($scope.getDeleteLabel(), TranslationService.get(''), $scope.revertDeletion);
    };
    $scope.revertDeletion = function() {
        $scope.lastDeleted.deleted = false;
        ToastService.hideExistingToast();
    };
    $scope.resetSelection = function() {
        $scope.step = 0;
        $scope.tempLineSet = {};
        $scope.tempLineSet.label = "";
        $scope.baseItem = {};
        $scope.showDialog = false;
        $scope.selection = {};
        $scope.toolbar = {};
        $scope.toolbar.search = "";
        if($scope.updateFunction) {
            $scope.updateFunction();
        }
    };
    $scope.resetSelection();

    $scope.deleteElement = function(item) {
        setFormAsDirty();
        item.deleted = true;
        $scope.lastDeleted = item;
        $scope.showDeletionToast(item);
        if($scope.updateFunction()) {
            $scope.updateFunction();
        }
    };
    $scope.toggleDialog = function() {
        $scope.showDialog = !$scope.showDialog;

        if($scope.showDialog) {
            ToastService.hideExistingToast();
            placePanel();
        }
    };

    function placePanel() {
        var mainView = angular.element('#ix-main-view');
        var mainViewBounding = mainView[0].getBoundingClientRect();
        var button = angular.element('#' + $scope.selectionId);
        var dialog = angular.element('#dialog' + $scope.selectionId);
        var buttonBounding = button[0].getBoundingClientRect();

        if (mainViewBounding.bottom < buttonBounding.bottom + 450 && (mainViewBounding.top + 64) < buttonBounding.bottom - 450) {
            dialog.css({
                position: 'relative',
                top: -450 + 'px'
            })
        }
        else {
            dialog.css({
                position: 'relative',
                top: 64 + 'px'
            })
        }
    }

    $(document).on('click', function(event) {
        if($(event.target).closest('#' + $scope.selectionId).length === 0) {
            $scope.showDialog = false;
            $scope.$evalAsync();
        }
    });
    $scope.back = function(event) {
        event.stopPropagation();
        if($scope.step === 3 && $scope.tempLineSet.anchor.companySetType != -3) {
            $scope.step--;
        }
        $scope.step--;
        $scope.toolbar.search = "";
    };
    $scope.cancel = function() {
        $scope.currentSelection = [];
        $scope.showDialog = false;
        $scope.goneSteps = [];
        $scope.goneSteps.push(0);
        $scope.stepIndex = 0;
        $scope.steps = [];
        $scope.step = 0;
    };
    $scope.selectBase = function(item) {
        $scope.toolbar.search = "";
        $scope.tempLineSet = {};
        $scope.tempLineSet.authSetId = item.id;
        $scope.tempLineSet.label = item.value;
        $scope.baseItem = item;
        if(item.needsCompanyAnchor) {
            $scope.step++;
        }
        else {
            $scope.sets.authSetEntries.push($scope.tempLineSet);
            setFormAsDirty();
            $scope.resetSelection();
        }
    };

    $scope.showOrganisationType = function(item) {
        return !$scope.baseItem.forceCompany || item.id === -2 || item.id === -3 ;
    }

    $scope.selectOrganisationType = function(item) {
        $scope.toolbar.search = "";
        $scope.tempLineSet.anchor = {};
        $scope.tempLineSet.anchor.companySetType = item.id;
        if(item.id === -3) {
            $scope.step++;
        }
        else {
            $scope.tempLineSet.label = $scope.tempLineSet.label + " " + $scope.fillWords.for + " " + item.value;
            if($scope.baseItem.needsCompanyRelation) {
                $scope.step = 3;
            }
            else {
                $scope.sets.authSetEntries.push($scope.tempLineSet);
                setFormAsDirty();
                $scope.resetSelection();
            }
        }
    };
    $scope.selectOrganisation = function(item) {
        $scope.toolbar.search = "";
        $scope.tempLineSet.label = $scope.tempLineSet.label + " " + $scope.fillWords.for + " " + item.value;
        $scope.tempLineSet.anchor.companySetId = item.id;
        if($scope.baseItem.needsCompanyRelation) {
            $scope.step = 3;
        }
        else {
            $scope.sets.authSetEntries.push($scope.tempLineSet);
            $scope.resetSelection();
        }
    };
    $scope.selectRelation = function(item) {
        $scope.toolbar.search = "";
        if (item.id !== "AssignedCompany")
        {
            $scope.tempLineSet.label = $scope.tempLineSet.label + " (" + item.value + ")";
        }
        $scope.tempLineSet.setCompanyRelation = {};
        $scope.tempLineSet.setCompanyRelation.value = item.id;
        if($scope.baseItem.needsCatalogRelation) {
            $scope.step = 4;
        }
        else {
            $scope.sets.authSetEntries.push($scope.tempLineSet);
            setFormAsDirty();
            $scope.resetSelection();
        }
    };
    $scope.save = function() {
        $scope.tempLineSet.setCatalogSelection = {};
        $scope.tempLineSet.label = $scope.tempLineSet.label + " " + $scope.fillWords.with + " " +
            $scope.sets.labelKatalogRechtsVermerk + " '" + $scope.selection.katalogRechtsVermerk + "'";
        $scope.tempLineSet.label = $scope.tempLineSet.label + " " + $scope.fillWords.and + " " +
            $scope.sets.labelKatalogSicht + " '" + $scope.selection.katalogSicht + "'";
        if($scope.selection.mitPreis) {
            $scope.tempLineSet.label = $scope.tempLineSet.label + " " + $scope.fillWords.and + " '" + $scope.sets.labelMitPreis + "'";
        }
        $scope.tempLineSet.setCatalogSelection.katalogRechtsVermerk = $scope.selection.katalogRechtsVermerk;
        $scope.tempLineSet.setCatalogSelection.katalogSicht = $scope.selection.katalogSicht;
        $scope.tempLineSet.setCatalogSelection.mitPreis = $scope.selection.mitPreis;
        $scope.sets.authSetEntries.push($scope.tempLineSet);
        setFormAsDirty();
        $scope.resetSelection();
    };

    function setFormAsDirty() {
        if($scope.formController) {
            $scope.formController.$setDirty();
        }
    }
}]);
